/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormDetail,
    FormDetailFromJSON,
    FormDetailFromJSONTyped,
    FormDetailToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormDetailsListResponse
 */
export interface FormDetailsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof FormDetailsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<FormDetail>}
     * @memberof FormDetailsListResponse
     */
    entries: Array<FormDetail>;
}

export function FormDetailsListResponseFromJSON(json: any): FormDetailsListResponse {
    return FormDetailsListResponseFromJSONTyped(json, false);
}

export function FormDetailsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormDetailsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(FormDetailFromJSON)),
    };
}

export function FormDetailsListResponseToJSON(value?: FormDetailsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(FormDetailToJSON)),
    };
}


